
    export default {
        name: 'index',
    };
